import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

import { ProductShippingInformationComponent } from "./components/product-shipping-information/product-shipping-information.component";

@NgModule({
    imports: [CommonModule, SrOnlyNoSnippetDirective],
    declarations: [ProductShippingInformationComponent],
    exports: [ProductShippingInformationComponent],
})
export class ProductShippingInformationModule {}
